[
  {"code": "en", "name": "English", "endonym": "English", "dir": "ltr", "required": true},
  {"code": "ar", "name": "Arabic", "endonym": "العربية", "dir": "rtl", "required": true}
]
